module.exports = __webpack_public_path__ + "static/img/shoe-active.b7ee2b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chargemeter/shoe-active.png
// module id = 570
// module chunks = 1